import type { JSX } from 'react'
import type { ISkeletonUnitProps } from '../../SkeletonUnit'

import { SkeletonUnit } from '../../SkeletonUnit'
import { SkeletonUnitDirection, SkeletonUnitWrap } from '../../SkeletonUnit.h'

export interface IChannelInfoWrapperSkeletonUnitProps extends ISkeletonUnitProps {}

export const ChannelInfoWrapperSkeletonUnit = ({
  children,
  width = '980px',
  direction = SkeletonUnitDirection.Row,
  flexWrap = SkeletonUnitWrap.Wrap,
  ...rest
}: IChannelInfoWrapperSkeletonUnitProps): JSX.Element => (
  <SkeletonUnit
    width={width}
    direction={direction}
    flexWrap={flexWrap}
    {...rest}
  >
    {children}
  </SkeletonUnit>
)
